export enum ContractStatusEsEnum {
    DRAFT = "Draft",
    PENDING = "Pending signtature",
    SIGNED = "Signed",
    VERIFICATION = "Verification and Scoring",
    VALIDATED = "Validated",
    ACTIVATED = "Activated",
    DESISTED = "Desisted",
    CANCELLED = "Cancelled",
    FINALIZED = "Finalized",
}
